import { useEffect, useState } from 'react';
import { getCatalog } from '../lib/catalog';

export default function useCatalog() {
  const [cat, setCat] = useState(getCatalog);
  useEffect(() => {
    const on = () => setCat(getCatalog());
    window.addEventListener('giss-catalog', on);
    return () => window.removeEventListener('giss-catalog', on);
  }, []);
  return cat;
}
